/**
 * Hook para recuperar contraseña. Usa authApi (Axios).
 */
import type { RecoverPasswordResponse } from "common/models";
import { useMutation, UseMutationResult, UseMutationOptions } from "react-query";
import { authApi } from "../api/authApi";

export function useRecoverPassword(
    options?: UseMutationOptions<RecoverPasswordResponse, unknown, number>
): UseMutationResult<RecoverPasswordResponse, unknown, number> {
    return useMutation(
        async (identifier: number) => {
            const { data } = await authApi.recoverPassword({ identifier });
            return data;
        },
        options
    );
}
